import BaseEvent from './BaseEvent.js';

class SnapshotEvent extends BaseEvent {
  handle() {
    this.context._api.takeSnapshot();
  }
}

export default SnapshotEvent;
